const STORAGE_KEY = "wembii-crm-show-monthly-expected";

export function loadCrmShowMonthlyExpected(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function saveCrmShowMonthlyExpected(show: boolean): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(show));
  } catch {
    // quota / private mode
  }
}
